import React, { useCallback } from 'react';
import { Table, TableContainer, TableBody } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import TableHeader from './TableHeader'
import TableRowMaterial from './TableRowMaterial'
import { formArrayAddManyUnique, formArrayDeleteMany } from '../../../../reducers/form';
import { makeStyles } from '@mui/styles';
import { createSelector } from 'reselect';

const useStyles = makeStyles(theme => ({
  container: {
    height: '80vh'
  },
}));


export const selectColumnKeys = createSelector(
  [(state, formName) => state.form[formName]?.values.column || {}],
  (column) => {
    const visible = [];
    let storage = null;
    let count = null;

    Object.keys(column).forEach(key => {
      const col = column[key];
      if (col?.visible) {
        visible.push(key);
      }
      if (col?.select === 'storageUnit') {
        storage = key;
      }

      if (col?.select === 'count') {
        count = key;
      }
    });
    return { visible, storage, count };
  }
);

export default function TableMain({ formName }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const allIds = useSelector(store => store.formTable[formName]?.allIds || [])
  const multiSelect = useSelector(store => store.form[formName]?.values.multiSelect || false)
  const { visible, storage, count } = useSelector((state) => selectColumnKeys(state, formName));

  const selectMulti = useCallback((indexOf, checked) => {
    dispatch((disp, getState) => {
      const state = getState()
      const allIds = state.formTable[formName]?.allIds || []
      const countSelect = state.form[formName]?.values.countSelect || 0
      const arrAdd = allIds.slice(indexOf, indexOf + countSelect)
      if (checked) {
        disp(formArrayAddManyUnique(arrAdd, { field: 'selectId', name: formName }))
      }
      else {
        disp(formArrayDeleteMany(arrAdd, { field: 'selectId', name: formName }))
      }
    })
  }, [dispatch, formName])  
  return <TableContainer className={classes.container}>
    <Table stickyHeader size='small' >
      <TableHeader formName={formName} />
      <TableBody>
        {allIds
          .map((row,i) => {
            return <TableRowMaterial
              key={row}
              row={row}
              index={i}
              selectMulti={selectMulti}
              multiSelect={multiSelect}
              formName={formName}
              column={visible}
              columnStorage={storage}
              columnCount={count}
            />
          })}
      </TableBody>
    </Table>
  </TableContainer>
}